export const BASE_URL_WEBSITE = 'https://mooncamp.com';
export const IMPRINT_URL = `${BASE_URL_WEBSITE}/imprint`;
export const PRIVACY_URL = `${BASE_URL_WEBSITE}/privacy-policy`;
export const TERMS_URL = `${BASE_URL_WEBSITE}/terms-of-service`;
